(function ($) {

    $(document).ready(function () {

        $('body').on('click', '.has-case-studies', function() {
            $('html, body').animate({scrollTop: $('.case-study-sticker').offset().top + 100});
        });

        if ($('.c-process').length) {
            $('.c-process__steps').slick({
                arrows: false,
                centerMode: true,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: "unslick"
                    }
                ]
            });
        }

        // Wow.js
        wow = new WOW(
            {
                mobile: false,
            }
        );
        wow.init();

        // Home page splash screen scroll arrow click
        $('.scroll-arrow').click(function () {
            $('body, html').animate({scrollTop: $(window).height()});
        });

        // Hamburger menu button animation and menu toggle
        $('.hamburger-btn').click(function () {
            $(this).toggleClass('active');
            $('#menu-hamburger-menu').toggleClass('visible');
            $('body').toggleClass('menu-visible');
        });

        // Concertina panel click events
        $('.panel-heading').click(function () {
            if ($(this).parent().hasClass('panel-active')) {
                $('.panel').removeClass('panel-active');
                $(this).find('.fa').removeClass('fa-minus').addClass('fa-plus');
            } else {
                $('.panel').removeClass('panel-active');
                $('.panel').find('.fa-minus').removeClass('fa-minus').addClass('fa-plus');
                $(this).find('.fa').removeClass('fa-plus').addClass('fa-minus');
                $(this).parent().addClass('panel-active');
            }
        });

        if ($('.circle-123').length) {
            $('.circle-123').on('click', '.circle-outer', function () {
                var $this = $(this);
                var $parent = $this.closest('.circle-123');

                if ($this.hasClass('active')) {
                    return;
                }

                $this.siblings().removeClass('active');
                $this.addClass('active');

                $parent.find('.content.active').fadeOut(200, function () {
                    $(this).removeClass('active');

                    $parent.find('.content:eq(' + $this.index() + ')').fadeIn(200, function () {
                        $(this).addClass('active');
                    });
                });
            });
        }

        // Position fixed home header on scroll
        if ($('body').hasClass('page-template-template-home')) {
            $(window).scroll(function () {
                if ($(window).scrollTop() > $(window).height()) {
                    $('.home-header').addClass('header-fixed');
                    $('.home-splash').addClass('home-splash-header-fixed');
                } else {
                    $('.home-header').removeClass('header-fixed');
                    $('.home-splash').removeClass('home-splash-header-fixed');
                }
            });
        }

        //Resources ALM equal heights
        if ($(window).width() > 992) {
            window.almComplete = function (alm) {
                $('.article:not(".featured")').each(function () {
                    var highestBox = 0;
                    $('.article:not(".featured")').each(function () {
                        if ($(this).height() > highestBox)
                            highestBox = $(this).height();
                    });
                    $('.article:not(".featured") .article-inner').height(highestBox);
                });
            };
        }

        if ($('.c-article').length) {
            if ($(window).width() > 767) {
                $('.c-article').each(function () {
                    var chighestBox = 0;
                    $('.c-article').each(function () {
                        if ($(this).height() > chighestBox)
                            chighestBox = $(this).height();
                    });
                    $('.c-article__article-inner').height(chighestBox);
                });
            }
        }

        // Clients page case study listing toggle
        if ($('body').hasClass('page-template-template-clients')) {
            $('.client-btn').click(function () {
                var client = $(this).attr('data-client');
                $('.client-case-study').hide();
                $('.' + client).show();
                $('.case-studies-listing').show();
                if ($(".client-case-study:visible").length === 0) {
                    $('.case-studies-listing').hide();
                } else {
                    $('.case-studies-listing').show();
                }

                if ($(".client-case-study.project-item:visible").length === 0) {
                    $('.projects-title').hide();
                } else {
                    $('.projects-title').show();
                }
                // Clients page scroll on click
            });
        }

        // Clients page case study listing toggle
        if ($('body').hasClass('page-template-template-contact')) {
            $('#contact-office-locations .btn').click(function(e){
                e.preventDefault();

                var $this = $(this);

                // Stop if current button is already active
                if ($this.hasClass('active')) {
                    return;
                }

                // Remove other active status
                $('#contact-office-locations .btn.active').removeClass('active');

                // Make this active
                $this.addClass('active');

                // Change to new map image
                $('#banner-map').css('background-image', "url('" + $this.data('map') + "')");
            });
        }

        if ($('.c-form').length) {
            $('.c-form .pre-form button').click(function() {
                $('.c-form .pre-form').hide();
                $('.c-form .hide-form').removeClass('hidden-state');
            });
        }
    });

    $(window).load(function () {
        $('.client-case-study').each(function () {
            var client = $(this).attr('data-client-casestudy');
            $('[data-client="' + client + '"]').find('.tooltip').addClass('tooltip-show');
            $('[data-client="' + client + '"]').addClass('has-case-studies');
        });
    });

})(jQuery); // Fully reference jQuery after this point.